import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import { ScrollContext } from 'react-router-scroll-4';
// import './index.scss';
import "./assets/css/style.css";
import "./assets/css/flag-icon.css";
import "./assets/css/fontawesome.css";
import "./assets/css/icofont.css";
import "./assets/css/animate.css";
import "./assets/css/bootstrap.css";
import "./assets/css/page-builder.css";
import "./assets/css/print.css";
import "./assets/css/prism.css";
import "./assets/css/svg-icon.css";
import "./assets/css/sweetalert2.css";
import "./assets/css/themify.css";
import "./assets/css/timepicker.css";
import "../src/assets/css/encss.css"


// ** Import custom components **
import store from './store';
import App from './components/app';

// Dashboards
// import Default from './components/dashboard/default/index.component'
import Error404 from './components/pages/error-404'
import Login from './components/pages/login'
import Register from './components/pages/register'
import ForgetPassword from './components/pages/forget-password'
import ResetPassword from './components/pages/reset-password'
import Comingsoon from './components/pages/comingsoon'
import Maintenance from './components/pages/maintenance'
import Consignments from './components/tracktrace/consolidatedScreen.js';
import RawCourierTracking from './components/tracktrace/rawcouriertracking.js';
import FTLConsignments from './components/tracktrace/FTLConsignments.js';
import PTLConsignments from './components/tracktrace/PTLConsignments.js';
import CourierConsignments from './components/tracktrace/CourierConsignments';
import Epod from './components/tracktrace/Epod';
import AddConsignment from './components/tracktrace/consignmentCreation.js';

import Dealers from './components/tracktrace/Dealers';
import Vehicles from './components/tracktrace/Vehicles';
import Invoice from './components/tracktrace/Invoice.js'
import TATmaster from './components/tracktrace/TATmaster.js'
import Usermaster from './components/tracktrace/usermaster.js'
import Locationmaster from './components/tracktrace/locationmaster.js';
import ODAmaster from './components/tracktrace/odamaster.js';
import Invoicemaster from './components/tracktrace/invoicemaster.js';
import Customermaster from './components/tracktrace/customermaster.js';
import TransporterAllocMaster from './components/tracktrace/transporterallocmaster.js';

import SimTracking from './components/tracktrace/SimTracking.js';
import Transporters from './components/tracktrace/Transporters';
import TransitTimes from './components/tracktrace/TransitTimes';
import TicketManagementSystem from './components/tracktrace/TicketManagementSystem';
import ApplicationIssues from './components/tracktrace/AppIssues.js';
import MobileTripMaps from "./components/tracktrace/mobiletripmaps.js";
import FTLTripMaps from "./components/tracktrace/ftltripmaps.js";
import TrackingConsignments from "./components/tracktrace/trackingConsignments.js";

import EnmUserLogin from "./components/pages/enmuserlogin.js";




import Geofence from './components/tracktrace/Geofence.jsx'
import AddGeofence from './components/tracktrace/AddGeofence.jsx'
import EditGeofence from './components/tracktrace/EditGeofence.jsx'
import Configuration from './components/tracktrace/configuration.jsx';
// import Default from './components/tracktrace/truckwithingeofence.js'
import TrucksWithInGeofence from './components/tracktrace/truckwithingeofence.js';
import ManageNearByConsignmentTrucks from './components/manage/consignment-nearby-trucks'
// import SafetyReport from './components/tracktrace/safetyreport.js';
import ConsignmentsGeofence from './components/layouts/consignmentgeofence.js';
import OptimizeDeviationRoutes from './components/tracktrace/PRTOptimizeDeviationRoutes.js';
import ChangePassword from './components/manage/changePassword.js';
import DailyRunningDashboardComponent from './components/dashboard/DailyRunningDashboardComponent.js';
import LoadingDashboard from './components/dashboard/summaryDashboardComponent.js';
import UnLoadingDashboard from './components/dashboard/unLoadingDashboardComponent';

import TransitAnalytics from './components/dashboard/trasitAnalytics';
// import DailyRunningDashboard from './components/dashboard/dailyrunningdashboard.js';
// import DailyRunningTransporter from './components/dashboard/dailyrunningtransporter.js';
import GPSDashboardComponent from './components/dashboard/gpsdashboardComponent.js';
import OnTimeDashboardComponent from './components/dashboard/ontimedashboardComponent.js';
import DeviationRoutes from './components/tracktrace/routeDeviationreportComponent.js';
import NightDriving from './components/dashboard/NightDriving';
import StoppageReport from './components/dashboard/StoppageReport';

import OverspeedReport from './components/dashboard/OverspeedReport';
import GenerateEwayBill from './components/ewaybill/generatenewewaybill.js';
import EwayBillData from './components/ewaybill/ewaybillsdata.js';
import EwayBillRequests from './components/ewaybill/ewaybillrequests.js';
import ConsolidateEwayBill from './components/ewaybill/consolidateewaybill.js';
import ConsolidateEwayBillRequests from './components/ewaybill/consolidateewaybillrequests.js';
import MenuSideBar from './components/common/sidebar/menuSidebar.jsx';
import DealerZoneWiseRoutes from './components/tracktrace/dealerZoneWiseRoutes.js';
import SavedBaseRoutes from './components/tracktrace/savedBaseRoutes.js';
import TopBaseRouteSummary from './components/tracktrace/topBaseRoutesSummary.js';
import DailyRunningTransporterDashboardComponent from './components/dashboard/dailrunningtransporterdashboardComponent.js';
import Samplepage from './components/icon/themify-icon.jsx';
import ManageConsignments from './components/tracktrace/sndgconsignments.jsx';
// import DailyRunningDashboardCharts from './components/tracktrace/dailyrunningroutewisedashboard.js';
import TPTTrucksGPSStatus from './components/layouts/tptTrucksGpsStatus.js';
import Dashboards from './components/dashboard/dashboardComponent.js';
// import Viewmap from './components/dashboard/viewmap.js';
import ShowMap from './components/dashboard/showmap.js';


import TransitDelayReport from './components/tracktrace/TransitDelayReport.js';
import ApiHealthCheck from './components/layouts/apihealthcheck.js';
import UserLogs from './components/layouts/userlogs.js';
import DeliveryPerformanceDashboard from './components/dashboard/deliveryPerformanceDashboardComponent.js';

import ProtectedRoute from "./components/common/protectedRoute";
import Unauthorized from "./components/common/unauthorized";
import CancelledSreen from './components/tracktrace/cancelledScreen.js';
import ForceCloseConsignments from './components/tracktrace/forceCloseConsignments.js';
import ConsignmentsDashboard from './components/tracktrace/landingDashboard.js';
import PerformanceDashboardModern from './components/tracktrace/performanceDashboardModern.js';
import { AutometricsExecutive, AutometricsNetwork, AutometricsFtl, AutometricsPod, AutometricsCo2, AutometricsExplorer } from './components/autometrics/AutometricsDashboard.js';
import BillingReport from './components/tracktrace/billingReport.js'


class Root extends React.Component {

    render() {
        return (
            <Provider store={store}>
                <Router basename={'/'}>
                    {/* <ScrollRestoration> */}
                    <Routes>
                        <Route path={"/"} element={<Login />} />
                        <Route path={`${process.env.PUBLIC_URL}/forgot-password`} element={<ForgetPassword />} />
                        <Route path={`${process.env.PUBLIC_URL}/mobiletripmap/:truckno`} element={<MobileTripMaps />} />
                        <Route path={`${process.env.PUBLIC_URL}/triptrackingview/:invoiceno*`} element={<FTLTripMaps />} />
                        {/* <Route path={`${process.env.PUBLIC_URL}/triptracking/:invoiceno*`} element={<TrackingConsignments />} /> */}   {/* Invoice based tracking -> PMS ID - 7672 */} 
                        {/* <Route path={`${process.env.PUBLIC_URL}/triptracking/:prefix?/:lrno`} element={<TrackingConsignments />} />  */}
                        <Route
                            path={`${process.env.PUBLIC_URL}/triptracking/:lrno/:entityType?`}
                            element={<TrackingConsignments />}
                        />
                        {/* <Route
                            path={`${process.env.PUBLIC_URL}/triptracking/:lrno`}
                            element={<TrackingConsignments />}
                        />
                         {/* LR based tracking -> PMS ID - 7672 */} 
                        <Route path={`${process.env.PUBLIC_URL}/map/:value`} element={<ShowMap />} /> 
                        <Route path="/enmuserlogin/:token" element={<EnmUserLogin />} />
                        <Route path="/unauthorized" element={<Unauthorized />} />

                        <Route element={<App />}>
                            <Route path={`${process.env.PUBLIC_URL}/rawcouriertracking`} element={<RawCourierTracking />} />
                            {/* <Route path={`${process.env.PUBLIC_URL}/dashboard/default`} element={<Default />    } /> */}
                            <Route path={`${process.env.PUBLIC_URL}/change-password`} element={<ChangePassword />} />
                            <Route path={`${process.env.PUBLIC_URL}/activeconsignments`} element={<Consignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/completedconsignments`} element={<Consignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/allconsignments`} element={<Consignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/activeftlconsignments`} element={<FTLConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/deliveredftlconsignments`} element={<FTLConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/allftlconsignments`} element={<FTLConsignments />} />

                            <Route path={`${process.env.PUBLIC_URL}/inactiveptlconsignments`} element={<PTLConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/activeptlconsignments`} element={<PTLConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/deliveredptlconsignments`} element={<PTLConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/allptlconsignments`} element={<PTLConsignments />} />
                            {/* <Route path={`${process.env.PUBLIC_URL}/sndconsignments`} element={<ManageConsignments />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/snddeliveredconsignments`} element={<ManageConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/sndallconsignments`} element={<ManageConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/epod`} element={<Epod />} />
                            <Route path={`${process.env.PUBLIC_URL}/addConsignment`} element={<AddConsignment />} />
                            {/* <Route path={`${process.env.PUBLIC_URL}/dealers`} element={<Dealers />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/dealers`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Dealers />
                                </ProtectedRoute>
                            } />


                            {/* <Route path={`${process.env.PUBLIC_URL}/tatmaster`} element={<TATmaster />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/tatmaster`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <TATmaster />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/locationmaster`} element={<Locationmaster />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/locationmaster`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Locationmaster />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/usermaster`} element={<Usermaster />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/usermaster`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                <Usermaster />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/usermaster`} element={<Usermaster />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/odamaster`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                <ODAmaster />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/usermaster`} element={<Usermaster />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/invoicemaster`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                <Invoicemaster />
                                </ProtectedRoute>
                            } />
                             {/* <Route path={`${process.env.PUBLIC_URL}/usermaster`} element={<Usermaster />} /> */}
                             <Route path={`${process.env.PUBLIC_URL}/customermaster`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                <Customermaster />
                                </ProtectedRoute>
                            } />
                             {/* <Route path={`${process.env.PUBLIC_URL}/usermaster`} element={<Usermaster />} /> */}
                             <Route path={`${process.env.PUBLIC_URL}/transporterallocationmaster`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                <TransporterAllocMaster />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/vehicles`} element={<Vehicles />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/vehicles`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Vehicles />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/transporters`} element={<Transporters />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/transporters`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Transporters />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/simtrackingdrivers`} element={<SimTracking />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/simtrackingdrivers`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound", "user-outbound","warehouse", "wh-inbound", "wh-outbound"]}>
                                    <SimTracking />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/transittimes`} element={<TransitTimes />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/transittimes`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <TransitTimes />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/ticketmanagementsystem`} element={<TicketManagementSystem />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/ticketmanagementsystem`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound", "user-outbound"]}>
                                    <TicketManagementSystem />
                                </ProtectedRoute>
                            } />
                             {/* <Route path={`${process.env.PUBLIC_URL}/ticketmanagementsystem`} element={<TicketManagementSystem />} /> */}
                             <Route path={`${process.env.PUBLIC_URL}/applicationissues`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <ApplicationIssues />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/transitDelayReport`} element={<TransitDelayReport />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/transitDelayReport`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound", "user-outbound"]}>
                                    <TransitDelayReport />
                                </ProtectedRoute>
                            } />

                            <Route path={`${process.env.PUBLIC_URL}/consignments/:tab`} element={<Consignments />} />

                            
                            <Route path={`${process.env.PUBLIC_URL}/activecourierconsignments`} element={<CourierConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/deliveredcourierconsignments`} element={<CourierConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/courierconsignments`} element={<CourierConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/consignments/cancelled_consignments`} element={<CancelledSreen />} />
                            <Route path={`${process.env.PUBLIC_URL}/consignments/force_close_consignments`} element={<ForceCloseConsignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/billingReport`} element={<BillingReport />} />


                            <Route path={`${process.env.PUBLIC_URL}/billingreportcourierconsignments`} element={<CourierConsignments />} />
                            {/* <Route path={`${process.env.PUBLIC_URL}/confignd`} element={<Configuration />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/performance_dashboard`} element={
                                <ProtectedRoute allowedRoles={["superadmin", "admin"]}>
                                    <ConsignmentsDashboard />
                                </ProtectedRoute>
                            } />
                            <Route path={`${process.env.PUBLIC_URL}/performance_dashboard_v2`} element={
                                <ProtectedRoute allowedRoles={["superadmin", "admin", "user", "user-inbound","user-outbound","warehouse", "wh-inbound", "wh-outbound"]}>
                                    <PerformanceDashboardModern />
                                </ProtectedRoute>
                            } />
                            {/* Autometrics dashboard v3 - one route per sidebar menu */}
                            <Route path={`${process.env.PUBLIC_URL}/autometrics/executive`} element={
                                <ProtectedRoute allowedRoles={["superadmin", "admin"]}>
                                    <AutometricsExecutive />
                                </ProtectedRoute>
                            } />
                            <Route path={`${process.env.PUBLIC_URL}/autometrics/network`} element={
                                <ProtectedRoute allowedRoles={["superadmin", "admin"]}>
                                    <AutometricsNetwork />
                                </ProtectedRoute>
                            } />
                            <Route path={`${process.env.PUBLIC_URL}/autometrics/ftl-utilization`} element={
                                <ProtectedRoute allowedRoles={["superadmin", "admin"]}>
                                    <AutometricsFtl />
                                </ProtectedRoute>
                            } />
                            <Route path={`${process.env.PUBLIC_URL}/autometrics/pod-compliance`} element={
                                <ProtectedRoute allowedRoles={["superadmin", "admin"]}>
                                    <AutometricsPod />
                                </ProtectedRoute>
                            } />
                            <Route path={`${process.env.PUBLIC_URL}/autometrics/co2`} element={
                                <ProtectedRoute allowedRoles={["superadmin", "admin"]}>
                                    <AutometricsCo2 />
                                </ProtectedRoute>
                            } />
                            <Route path={`${process.env.PUBLIC_URL}/autometrics/shipments`} element={
                                <ProtectedRoute allowedRoles={["superadmin","admin"]}>
                                    <AutometricsExplorer />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/confignd`} element={<Configuration />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/confignd`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Configuration />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/configospd`} element={<Configuration />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/configospd`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Configuration />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/confignogps`} element={<Configuration />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/confignogps`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Configuration />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/configstoppages`} element={<Configuration />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/configstoppages`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Configuration />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/configldelay`} element={<Configuration />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/configldelay`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Configuration />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/configudelay`} element={<Configuration />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/configudelay`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Configuration />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/gpsintegration`} element={<TrucksWithInGeofence />} /> */}
                            {/* <Route path={`${process.env.PUBLIC_URL}/snddepartmentvicinity/sndg`} element={<TrucksWithInGeofence />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/snddepartmentvicinity/sndg`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound", "user-outbound"]}>
                                    <TrucksWithInGeofence />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/nearbysndvehicles`} element={<ManageNearByConsignmentTrucks />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/nearbysndvehicles`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound","user-outbound"]}>
                                    <ManageNearByConsignmentTrucks />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/sndsafetyreport`} element={<SafetyReport />} /> */}
                            {/* <Route path={`${process.env.PUBLIC_URL}/sndgeofence`} element={<ConsignmentsGeofence />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/sndgeofence`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound","user-outbound"]}>
                                    <ConsignmentsGeofence />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/optimizeroutes`} element={<OptimizeDeviationRoutes />} /> */}
                            {/* <Route path={`${process.env.PUBLIC_URL}/deviationroutes`} element={<DeviationRoutes />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/deviationroutes`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound","user-outbound"]}>
                                    <DeviationRoutes />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/dailyrunningdashboard`} element={<DailyRunningDashboardComponent />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/dailyrunningdashboard`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound","user-outbound"]}>
                                    <DailyRunningDashboardComponent />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/sndloadingdashboard`} element={<LoadingDashboard />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/sndloadingdashboard`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound","user-outbound"]}>
                                    <LoadingDashboard />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/sndunloadingdashboard`} element={<UnLoadingDashboard />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/sndunloadingdashboard`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound","user-outbound"]}>
                                    <UnLoadingDashboard />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/deliveryperfdashboard`} element={<DeliveryPerformanceDashboard />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/deliveryperfdashboard`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <DeliveryPerformanceDashboard />
                                </ProtectedRoute>
                            } />

                            {/* <Route path={`${process.env.PUBLIC_URL}/sndtransitanalytics`} element={<TransitAnalytics />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/sndtransitanalytics`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound","user-outbound"]}>
                                    <TransitAnalytics />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/sndtransportdashboard`} element={<DailyRunningTransporterDashboardComponent />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/sndtransportdashboard`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound","user-outbound"]}>
                                    <DailyRunningTransporterDashboardComponent />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/sndgpsdashboard`} element={<GPSDashboardComponent />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/sndgpsdashboard`} element={
                                <ProtectedRoute allowedRoles={["admin","user","user-inbound","user-outbound"]}>
                                    <GPSDashboardComponent />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/ontimedashboard`} element={<OnTimeDashboardComponent />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/ontimedashboard`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <OnTimeDashboardComponent />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/nightdriving`} element={<NightDriving />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/nightdriving`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <NightDriving />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/overspeedreport`} element={<OverspeedReport />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/overspeedreport`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <OverspeedReport />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/stoppagereport`} element={<StoppageReport />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/stoppagereport`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <StoppageReport />
                                </ProtectedRoute>
                            } />

                            {/* <Route path={`${process.env.PUBLIC_URL}/generatenewewaybill`} element={<GenerateEwayBill />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/generatenewewaybill`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <GenerateEwayBill />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/ewaybilldata/1`} element={<EwayBillData />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/ewaybilldata/1`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <EwayBillData />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/ewaybilldata/2`} element={<EwayBillData />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/ewaybilldata/2`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <EwayBillData />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/ewaybilldata/3`} element={<EwayBillData />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/ewaybilldata/3`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <EwayBillData />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/ewaybillrequests`} element={<EwayBillRequests />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/ewaybillrequests`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <EwayBillRequests />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/consolidateewaybill`} element={<ConsolidateEwayBill />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/consolidateewaybill`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <ConsolidateEwayBill />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/consolidateewaybillrequests`} element={<ConsolidateEwayBillRequests />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/consolidateewaybillrequests`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <ConsolidateEwayBillRequests />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/ewaybillreport`} element={<EwayBillData />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/ewaybillreport`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <EwayBillData />
                                </ProtectedRoute>
                            } />
                            <Route path={`${process.env.PUBLIC_URL}/sidebar`} element={<MenuSideBar />} />

                            
                            <Route path={`${process.env.PUBLIC_URL}/iconsssss`} element={<Samplepage />} />

                            {/* <Route path={`${process.env.PUBLIC_URL}/optimizeroutes`} element={<OptimizeDeviationRoutes />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/optimizeroutes`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <OptimizeDeviationRoutes />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/dealerzonewiseroutes`} element={<DealerZoneWiseRoutes />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/dealerzonewiseroutes`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <DealerZoneWiseRoutes />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/deviationanalysisdata`} element={<DeviationRoutes />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/deviationanalysisdata`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <DeviationRoutes />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/saproutes`} element={<SavedBaseRoutes />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/saproutes`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <SavedBaseRoutes />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/topbaseroutessummary`} element={<TopBaseRouteSummary />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/topbaseroutessummary`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <TopBaseRouteSummary />
                                </ProtectedRoute>
                            } />
                            

                            {/* <Route path={`${process.env.PUBLIC_URL}/geofence`} element={<Geofence />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/geofence`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <Geofence />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/addgeofence`} element={<AddGeofence />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/addgeofence`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <AddGeofence />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/editgeofence`} element={<EditGeofence />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/editgeofence`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <EditGeofence />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/editGeofence/:geofencename`}  element={<EditGeofence />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/editGeofence/:geofencename`} element={
                                <ProtectedRoute allowedRoles={["admin"]}>
                                    <EditGeofence />
                                </ProtectedRoute>
                            } />


                            <Route path={`${process.env.PUBLIC_URL}/consignments-active`} element={<Consignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/consignments-delivered`} element={<Consignments />} />
                            <Route path={`${process.env.PUBLIC_URL}/consignments-all`} element={<Consignments />} />
                            {/* <Route path={`${process.env.PUBLIC_URL}/dailyrunningdelivereddashboard`} component={DailyRunningDashboardCharts} /> */}
                            {/* <Route path={`${process.env.PUBLIC_URL}/tpttruckgpsstatus`} element={<TPTTrucksGPSStatus />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/tpttruckgpsstatus`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <TPTTrucksGPSStatus />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/snddashboard`} element={<Dashboards />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/snddashboard`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <Dashboards />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/viewmap`} element={<Viewmap />} /> */}
                            {/* <Route path={`${process.env.PUBLIC_URL}/sndgapihealthcheck`} element={<ApiHealthCheck />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/sndgapihealthcheck`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <ApiHealthCheck />
                                </ProtectedRoute>
                            } />
                            {/* <Route path={`${process.env.PUBLIC_URL}/userlogs`} element={<UserLogs />} /> */}
                            <Route path={`${process.env.PUBLIC_URL}/userlogs`} element={
                                <ProtectedRoute allowedRoles={["admin","user", "user-inbound","user-outbound"]}>
                                    <UserLogs />
                                </ProtectedRoute>
                            } />

                            </Route>
                            

                    </Routes>
                    {/* </ScrollRestoration> */}
                </Router>
            </Provider>
        )
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);


